import HttpClient from '../httpClient';

class CandidateClarityController extends HttpClient {
  startGeneration = async (payload: object, token: string) => {
    const response = await this.client.post(
      '/generateCandidateClarityQuestions',
      payload,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };

  getGenerationStatus = async (
    orgId: string,
    jobId: string,
    requestId: string,
    token: string,
  ) => {
    const response = await this.client.get(
      `/candidateClarityQuestionsStatus/${orgId}/${jobId}/${requestId}`,
      {
        headers: {
          Authorization: token,
        },
      },
    );
    return response.data;
  };
}

export default new CandidateClarityController(
  process.env.REACT_APP_API_URL_ENTERPRISE,
);
